import { DropdownItem } from '@/main/store/@types/dropdown.d';

export const edit = {
	BarvaKod: null as string | null,
	BarvaText: null as string | null,
	CenaOdhad: null as number | null,
	CenaOdhadM2: null as number | null,
	DoklPdfFileName: null as string | null,
	EMailAdresa: null as string | null,
	EditDat: null as string | null,
	EditPracId: null as number | null,
	HotovoDat: null as Date | null,
	IcoNr: null as string | null,
	InfMailAdresa: null as string | null,
	InfMailPrp: null as boolean | null,
	InfSmsPrp: null as boolean | null,
	InfSmsTelNr: null as string | null,
	Jmeno: null as string | null,
	KaroserieNr: null as string | null,
	KategOzn: null as number | null,
	KmStav: null as number | null,
	KmStavOut: null as number | null,
	KurzM2: null as number | null,
	Kurzstr: null as string | null,
	MenaId1: null as number | null,
	MenaId2: null as number | null,
	ModelRok: null as string | null,
	MotorKod: null as string | null,
	MotorNr: null as string | null,
	NarozeniDat: null as string | null,
	NdUlozitPrp: null as boolean | null,
	Obec: null as string | null,
	ObjednavkaNr: null as string | null,
	Osloveni: null as string | null,
	PDicNr: null as string | null,
	PFirma: null as string | null,
	PIcoNr: null as string | null,
	PObec: null as string | null,
	PTelfmaNr: null as string | null,
	PTelmobNr: null as string | null,
	PUlice: null as string | null,
	PalivoStav: null as number | null,
	PlatbahnedPrp: null as boolean | null,
	Prijmtechnik: null as string | null,
	ProdejDat: null as string | null,
	PscNr: null as string | null,
	RpzvCommunicStatusPzn: null as number | null,
	Spz: null as string | null,
	StanovisteNr: null as string | null,
	TelfmaNr: null as string | null,
	TelmobNr: null as string | null,
	TelprivNr: null as string | null,
	Text: null as string | null,
	TiskDat: null as string | null,
	Typkod: null as string | null,
	TypkodText: null as string | null,
	Ulice: null as string | null,
	VrEMailAdresa: null as string | null,
	VrJmeno: null as string | null,
	VrOsobniCis: null as string | null,
	VrPrijmeni: null as string | null,
	VrTelNr: null as string | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	VstupProvId: null as number | null,
	Vybava: null as string | null,
	VyrobekvozOzn: null as string | null,
	ZakazkaDruh: null as string | null,
	ZakazkaStav: null as number | null,
	ZakazkaId: null as number | null,
	ZakazkaNr: null as number | null,
	ZakazkalistId: null as number | null,
	ZakaznikId: null as number | null,
	ZodpovosobaId: null as number | null,
	RpzvPrp: null as boolean | null,
	IsApproveShow: true as boolean | true,
	EnableRegionFlag: null as boolean | null,
	EnableRegionFlagForWatchlisted: null as boolean | null,
	SourceTypePrp: null as boolean | null,
	OrderSubtypeId: null as number | null,
	VozidloId: null as number | null,
};

export const dropdownList = {
	VybavaVoz: [] as DropdownItem[],
	RPZV: [] as DropdownItem[],
	Mena: [] as DropdownItem[],
	SourceType: [] as DropdownItem[],
};

export const localState = {
	vybavaSelectValue: '',
	kurzy: null as any,
	meny: null,
	VozidloId: null as string | null,
	lastStavKm: null as number | null,
	rpzvSent: false,
	showDialogPendingJoblist: false as boolean | null,
};
